import { ServiceFetch } from '../service-fetch'

export default class OrderListModel extends ServiceFetch {
  getOrderListBy = (data) => this.authFetch({
    url: 'order-list/getOrderListBy',
    method: 'POST',
    body: JSON.stringify(data),
  })
}
